import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {LuikType} from "../../Model";
import paneelluikImage from '../../images/luik/paneelluik.jpg'
import louvreluikImage from '../../images/luik/louvreluik.jpg'
import vlakluikImage from '../../images/luik/vlakluik.jpg'
import vensterluikZichtbaarImage from '../../images/luik/vensterluikZichtbaar.jpg'
import vensterluikOnzichtbaarImage from '../../images/luik/vensterluikOnzichtbaar.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";
import PickerInfoBox from "../../components/PickerInfoBox";

TypePick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export default function TypePick(props) {
    const currentValue = props.allValues.TypePick;

    return (
        <div className="page">
            <PhoneAppHeader title="Luiktype"
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={props.handlePreviousPage}/>

            <div className="phone-page-middle">
                <h1 className="phone-pick-title">Voor welk luiktype heeft u beslag nodig?</h1>

                <div className="phone-pick-body">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={LuikType.PANEELLUIK}
                                      image={paneelluikImage}
                                      small/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={LuikType.LOUVRELUIK}
                                      image={louvreluikImage}
                                      small/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={LuikType.VLAKLUIK}
                                      image={vlakluikImage}
                                      hintText={"Voor- en achterzijde gelijk, vlakke plaat"}
                                      small/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={LuikType.VENSTERLUIK_VISIBLE_CLAMS}
                                      image={vensterluikZichtbaarImage}
                                      hintText={"Klampen in het zicht als de luiken open zijn"}
                                      small/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={LuikType.VENSTERLUIK_INVISIBLE_CLAMS}
                                      image={vensterluikOnzichtbaarImage}
                                      hintText={"Klampen naar de muur als de luiken open zijn"}
                                      small/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: LuikType.OTHER, text: ""}}
                                      child
                                      image={otherImage}
                                      small/>
                </div>

                <PickerInfoBox
                    options={[
                        {value: LuikType.PANEELLUIK, text: "Paneelluiken bestaan uit een kader (raamwerk) en een vlak paneel"},
                        {value: LuikType.LOUVRELUIK, text: "Louvreluiken hebben een kader met daarin lamellen opgesloten"},
                        {value: LuikType.VLAKLUIK, text: "Voor- en achterzijde gelijk, vlakke plaat"},
                        {value: LuikType.VENSTERLUIK_VISIBLE_CLAMS, text: "Klampen in het zicht als de luiken open zijn"},
                        {value: LuikType.VENSTERLUIK_INVISIBLE_CLAMS, text: "Klampen naar de muur als de luiken open zijn"},
                        {value: LuikType.OTHER, text: "Omschrijf hier uw gewenste situatie", withInput: true},
                    ]}
                    current={currentValue}
                    onChangeCurrent={props.handlePageChange}
                />
            </div>
            <PhoneAppFooter onNext={props.handleNextPage}
                       enableNext={!!currentValue}/>
        </div>
    );
}
